import { ADD, DELETE, EDIT, LIST, VIEW } from "const"
import { LangType } from "client/store"
import Lang from "client/store/lang"

import * as Const from "./const"
import {
    PermissionStructure,
    ProjectPermissions,
    ProjectPermissionsSectioned,
} from "./types"
import {
    copyPermissionRow,
    projectPermissionRow,
} from "./functions"

// eslint-disable-next-line import/prefer-default-export
export const createProjectPermissions = (targetLang?: LangType) => {
    const lang = targetLang || Lang
    const structure: PermissionStructure = {
        project: [
            {
                permissionId: Const.PRM_TEAM,
                title: lang.team,
                unused: [LIST, ADD, DELETE],
            },
            {
                permissionId: Const.PRM_PERMISSIONS,
                title: lang.permissions,
                unused: [VIEW, ADD, DELETE],
            },
            {
                permissionId: Const.PRM_PROJECT_SETTINGS,
                title: lang.projectSettings,
                unused: [LIST, ADD, DELETE],
            },
            {
                permissionId: Const.PRM_TASK,
                title: lang.task,
            },
            {
                permissionId: Const.PRM_DRIVE,
                title: lang.drive,
            },
            {
                permissionId: Const.PRM_COMMENTS,
                title: lang.comments,
                unused: [LIST, VIEW, ADD],
            },
        ],
        complianceCase: [
            {
                permissionId: Const.PRM_CC_COMPLIANCE,
                title: lang.compliance,
                unused: [LIST, ADD, DELETE],
            },
            {
                permissionId: Const.PRM_CC_REVIEW,
                title: lang.review,
                unused: [LIST],
            },
            {
                permissionId: Const.PRM_CC_REQUIREMENT,
                title: lang.requirements,
            },
            {
                permissionId: Const.PRM_CC_REQUIREMENT_REVIEW,
                title: lang.requirementsReview,
                unused: [LIST, ADD, DELETE],
            },
            {
                permissionId: Const.PRM_CC_DRAFTS,
                title: lang.drafts,
                unused: [LIST, ADD, EDIT, DELETE],
            },
            {
                permissionId: Const.PRM_CC_LIBRARY,
                title: lang.library,
            },
            {
                permissionId: Const.PRM_CC_RESULTS_PDF,
                title: lang.resultsPDF,
                unused: [LIST, ADD, EDIT, DELETE],
            },
        ],
        lifecycle: [
            {
                permissionId: Const.PRM_LIFECYCLE,
                title: lang.lifecycle,
            },
        ],
        sil: [
            {
                permissionId: Const.PRM_SIL_DEVICE,
                title: lang.device,
            },
            {
                permissionId: Const.PRM_SIL_SUBSYSTEM,
                title: lang.subsystem,
            },
            {
                permissionId: Const.PRM_SIL_SAFETY_FUNCTION,
                title: lang.safetyFunction,
            },
            {
                permissionId: Const.PRM_SIL_RESULTS,
                title: lang.results,
                unused: [LIST, ADD, EDIT, DELETE],
            },
            {
                permissionId: Const.PRM_SIL_RESULTS_PDF,
                title: lang.resultsPDF,
                unused: [LIST, ADD, EDIT, DELETE],
            },
        ],
        rrs: [
            /* { TODO: temporarily disabled
                permissionId: Const.PRM_RRS_CATEGORY,
                title: lang.lexicon,
                unused: [VIEW],
            }, */
            {
                permissionId: Const.PRM_RRS_TEMPLATE,
                title: lang.riskSpaceTemplates,
            },
        ],
        study: [
            {
                permissionId: Const.PRM_STUDY,
                title: lang.study,
            },
            {
                permissionId: Const.PRM_STUDY_SESSION,
                title: lang.session,
            },
        ],
    }

    const { permissions, permissionsSectioned } = copyPermissionRow(structure, projectPermissionRow)
    return {
        permissions: <ProjectPermissions>permissions,
        permissionsSectioned: <ProjectPermissionsSectioned>permissionsSectioned,
    }
}
